import { ClickawayListener } from './ClickawayListener/ClickawayListener'
import { FirebaseInitializer } from './FirebaseInitializer/FirebaseInitializer'
import { GoogleAnalyticsInitializer } from './GoogleAnalyticsInitializer/GoogleAnalyticsInitializer'
import { KeyboardListener } from './KeyboardListener/KeyboardListener'
import { MediavineInitializer } from './MediavineInitializer/MediavineInitializer'
import { ScrollListener } from './ScrollListener/ScrollListener'

export const WindowListeners = () => (
  <>
    <ClickawayListener />
    <FirebaseInitializer />
    <GoogleAnalyticsInitializer />
    <KeyboardListener />
    <MediavineInitializer />
    <ScrollListener />
  </>
)
